const kids = {
  state: {
    kids: [
      // { id: 1, name: 'Foo' },
      // { id: 2, name: 'Bar' }
    ]
  },

  getters: {
    // this.$store.getters.getKidById(1)
    getKidById: state => id => {
      return state.kids.find(kid => kid.id === id);
    },

    getKids: state => {
      return state.kids;
    }
  },

  mutations: {
    addKid(state, kid) {
      state.kids.push(kid);
    },

    setKids(state, kids) {
      state.kids = kids;
    }
  }
};

export default kids;



// WEBPACK FOOTER //
// ./src/store/kids.js